import React from "react";
import { makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import { useQuery } from "react-query";
import { useParams } from "react-router";
import { AvatarWithStatus } from "../../../../components/AvatarWithStatus";
import Error from "../../../../components/Error";
import FontIcon from "../../../../components/FontIcon";
import IconButton from "../../../../components/IconButton";
import Loading from "../../../../components/Loading";
import { mutateErrors } from "../../../../utils";
import { useWizard } from "../../../wizard/context";
import useUserQueries from "../../hooks/useUserQueries";
import UserAccount from "../../userAccount";
import { useUpdateProfileConfig } from "../../userAccount/modals/EditProfile/config";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
  },
  name: {
    fontSize: 18,
    color: "#192130",
    fontWeight: 500,
    marginLeft: 10,
  },
  actionButton: {
    marginLeft: 7,
    padding: 7,
    "& .MuiIcon-root": {
      fontSize: 12,
    },
  },
}));

export default function UserAccountPage() {
  const params = useParams<{ id: string }>();
  const { fetchOne } = useUserQueries();
  const { openWizard } = useWizard();

  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>("user_account_" + params.id, () => {
      return fetchOne(params.id);
    });

  const user = data?.data;

  const updateProfileConfig = useUpdateProfileConfig(user);

  const editProfile = async () => {
    const result = await openWizard(updateProfileConfig);

    if (result) {
      refetch();
    }
  };

  const classes = useStyles();

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <>
      <Container maxWidth="lg">
        <div className={classes.buttonContainer}>
          <AvatarWithStatus
            src={user.photo?.preview}
            alt="User Photo"
            size={85}
            borderWidth={2}
          />
          <div className={classes.name}>{user.name}</div>
          <IconButton
            color={"edit"}
            className={classes.actionButton}
            onClick={editProfile}
          >
            <FontIcon name={"edit"} />
          </IconButton>
        </div>
      </Container>

      <UserAccount user={user} onUpdate={refetch} />
    </>
  );
}
